import { Color } from '../../../enums/color'
import { IconName } from '../../Icon'
import { Variant } from '../types/variant'

interface AlertStyles {
  color: Color
  bgColor: Color
  icon: IconName
}

export const variantStyles: Record<Variant, AlertStyles> = {
  error: {
    color: Color.White,
    bgColor: Color.Red700,
    icon: 'circleAlert',
  },
  warning: {
    color: Color.Black,
    bgColor: Color.Yellow400,
    icon: 'circleAlert',
  },
  info: {
    color: Color.Grey950,
    bgColor: Color.Lavender100,
    icon: 'info',
  },
  success: {
    color: Color.White,
    bgColor: Color.Green700,
    icon: 'circleCheck',
  },
}
